export default __webpack_public_path__ + "static/media/image1.7133dfa0.svg";